module.exports = __webpack_public_path__ + "static/media/TA274_2.3ac0e774.png";